import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LogoComponent } from '../logo/logo.component';

@Component({
  selector: 'app-login-layout',
  imports: [LogoComponent],
  templateUrl: './login-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './login-layout.component.scss',
})
export class LoginLayoutComponent {}
